import { render, staticRenderFns } from "./ProductCardTable.vue?vue&type=template&id=74dff2a2"
import script from "./ProductCardTable.vue?vue&type=script&lang=js"
export * from "./ProductCardTable.vue?vue&type=script&lang=js"
import style0 from "./ProductCardTable.vue?vue&type=style&index=0&id=74dff2a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports